interface Props {
    variant?: string;
    width?: string;
    height?: string;
    lines?: number;
    className?: string;
}

export function MkSkeleton({ variant = "text", width, height, lines = 1, className }: Props) {
    const style = {
        ...(width ? { width } : {}),
        ...(height ? { height } : {}),
    };
    return (
        <div className={`mk-skeleton-group${className ? ` ${className}` : ""}`}>
            {Array.from({ length: lines }, (_, index) => (
                <span key={index} className={`mk-skeleton mk-skeleton-${variant}`} style={style} />
            ))}
        </div>
    );
}
